module.exports = __webpack_public_path__ + "img/investmentplaner.44974feb.jpg";